/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Manageroles_Description1Inputs */

const en_settings_collaborators_manageroles_description1 = /** @type {(inputs: Settings_Collaborators_Manageroles_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the collaborators whose roles you want to change.`)
};

/**
* | output |
* | --- |
* | "Select the collaborators whose roles you want to change." |
*
* @param {Settings_Collaborators_Manageroles_Description1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_manageroles_description1 = /** @type {((inputs?: Settings_Collaborators_Manageroles_Description1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Manageroles_Description1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_manageroles_description1(inputs)
});
export { settings_collaborators_manageroles_description1 as "settings_collaborators_manageRoles_description" }